import { render } from "./KapibaraMain.vue?vue&type=template&id=79a5d20c"
import script from "./KapibaraMain.vue?vue&type=script&lang=js"
export * from "./KapibaraMain.vue?vue&type=script&lang=js"

import "./KapibaraMain.vue?vue&type=style&index=0&id=79a5d20c&lang=scss"

import exportComponent from "D:\\experement\\kapibara\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__